import type { ProcessingFeeModel } from '@domain-group/realhub-backend-api-types'
import type { EntitiesState } from '@redux/entities'

type MatchFilterServiceParams = {
  filters: {
    service_id?: number,
  },
  processingFee: ProcessingFeeModel,
  serviceProducts: EntitiesState['serviceProducts'],
}

export const matchFilterService = (params: MatchFilterServiceParams) => {
  const { filters, processingFee, serviceProducts } = params

  const { billable_id, billable_type } = processingFee
  const { service_id } = filters

  if (!service_id) return true

  const serviceProduct = billable_type === 'ServiceProduct' ? serviceProducts[billable_id] : undefined

  const billableId = serviceProduct?.service_id || billable_id

  return billableId === service_id
}

const getServiceId = (processingFee: ProcessingFeeModel, serviceProducts: EntitiesState['serviceProducts']) => {
  const { billable_id, billable_type } = processingFee

  if (billable_type !== 'ServiceProduct') return null
  return serviceProducts[billable_id]?.service_id
}

export type GroupedProcessingFeesType = {
  [key: number]: {
    serviceProcessingFee: ProcessingFeeModel,
    productProcessingFees: ProcessingFeeModel[],
  },
}

export const groupProcessingFees = (
  filteredProcessingFees: ProcessingFeeModel[],
  serviceProducts: EntitiesState['serviceProducts'],
) => (
  filteredProcessingFees.reduce((acc: GroupedProcessingFeesType, processingFee) => {
    const { billable_id, billable_type } = processingFee
    const serviceId = billable_type === 'Service' ? billable_id : getServiceId(processingFee, serviceProducts)

    if (!serviceId) return acc

    if (!acc[serviceId]){
      // @ts-expect-error TS2741
      acc[serviceId] = { productProcessingFees: [] }
    }

    const serviceObject = acc[serviceId]

    // Group Service Product processingFees by service. Add Service lead time if present.
    if (billable_type === 'Service') serviceObject.serviceProcessingFee = processingFee
    if (billable_type === 'ServiceProduct') serviceObject.productProcessingFees.push(processingFee)

    return acc
  }, {})
)

export default matchFilterService
